{
    "ammoniumNitrate": {
        "type": "checkbox",
        "fields": {
            "id": "#ammoniumNitrate",
            "selectedClass": ".ammoniumnitrateSelected",
            "reviewId": "#review_ammoniumNitrate",
            "groupClass": ".explosivesProduct",
            "nextSelectedClass": ".nitricAcidSelected"
        }
    },
    "nitricAcid": {
        "type": "checkbox",
        "fields": {
            "id": "#NitricAcid",
            "selectedClass": ".nitricAcidSelected",
            "reviewId": "#review_nitricAcid",
            "groupClass": ".explosivesProduct",
            "nextSelectedClass": ".ammoniumnitrateSelected"
        }
    },
    "farmingGarden": {
        "type": "checkbox",
        "fields": {
            "id": "#farmingGarden",
            "selectedClass": ".farmingGardenSelected",
            "reviewId": "#review_farmingGarden",
            "groupClass": ".companyType",
            "nextSelectedClass": ".resellerSelected"
        }
    },
    "reseller": {
        "type": "checkbox",
        "fields": {
            "id": "#reseller",
            "selectedClass": ".resellerSelected",
            "reviewId": "#review_reseller",
            "groupClass": ".companyType",
            "nextSelectedClass": ".farmingGardenSelected"
        }
    },
    "customerName": {
        "type": "text",
        "fields": {
            "id": "#customerName",
            "reviewId": "#review_customerName"

        }
    },
    "customerAddress": {
        "type": "text",
        "fields": {
            "id": "#customerAddress",
            "reviewId": "#review_customerAddress"

        }
    },
    "customerZipCodeAndCity": {
        "type": "text",
        "fields": {
            "id": "#customerZipCodeAndCity",
            "reviewId": "#review_customerZipCodeAndCity"

        }
    },
    "customerOrganizationNumber": {
        "type": "text",
        "fields": {
            "id": "#customerOrganizationNumber",
            "reviewId": "#review_customerOrganizationNumber"

        }
    }

}
